import { countDecimals } from './countDecimals'

function convertNumberToDecimalString(value) {
  const data = String(value).split(/[eE]/)

  // Если в числе нет "e", возвращаем строку с этим числом как есть
  if (data.length == 1) return data[0]

  let z = ''
  const sign = value < 0 ? '-' : ''
  const str = data[0].replace('.', '')
  let mag = Number(data[1]) + 1

  if (mag < 0) {
    z = `${sign}0.`
    while (mag < 0) {
      mag += 1
      z += '0'
    }
    return z + str.replace(/^-/, '')
  }

  mag -= str.length
  while (mag > 0) {
    z += '0'
    mag -= 1
  }
  return str + z
}

// Truncate extra figures for the value
// Return string with truncated numeric value
function truncateExtraDecimals(value, allowedDecimalsNumber) {
  const stringWithDecimals = convertNumberToDecimalString(value)

  if (countDecimals(stringWithDecimals) <= allowedDecimalsNumber) {
    return stringWithDecimals
  }

  const truncatedValue =
    Math.trunc(value * 10 ** allowedDecimalsNumber) /
    10 ** allowedDecimalsNumber

  return convertNumberToDecimalString(truncatedValue)
}

export { truncateExtraDecimals }
